import { render } from "./DashB.vue?vue&type=template&id=80a05688&scoped=true"
import script from "./DashB.vue?vue&type=script&lang=js"
export * from "./DashB.vue?vue&type=script&lang=js"

import "./DashB.vue?vue&type=style&index=0&id=80a05688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a05688"]])

export default __exports__